@if (!outlined) {
  <button
    [disabled]="disabled"
    (click)="onClick.emit($event)"
    class="icon {{ icon }} {{ dimension ? 'has-dimension' : size }} {{ fontSize }} rounded-full"
    [ngClass]="getButtonClasses()"
    [ngStyle]="dimensionStyle"
    [style.backgroundColor]="overrideBackgroundColor | contentBuilderColor"
    [style.color]="overrideColor | contentBuilderColor"
    [style.borderColor]="type === 'outlined' ? (overrideColor | contentBuilderColor) : ''"
  ></button>
}
@if (outlined) {
  <button
    [disabled]="disabled"
    (click)="onClick.emit($event)"
    class="icon {{ icon }} {{ dimension ? 'has-dimension' : size }} {{ fontSize }} rounded-full"
    [ngClass]="getButtonClasses()"
    [ngStyle]="dimensionStyle"
    [style.backgroundColor]="overrideBackgroundColor | contentBuilderColor"
    [style.color]="overrideColor | contentBuilderColor"
  ></button>
}
